import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './router/config';
import { LoadingSpinner } from './components/LoadingSpinner';
import { DefaultSEO } from './components/SEO/DefaultSEO';
import { useAuthContext } from './context/AuthContext';
import { usePresence } from './hooks/usePresence';

export function App() {
  const { user, loading } = useAuthContext();
  const { updateStatus } = usePresence();

  // Initialize presence tracking when app loads
  useEffect(() => {
    let cleanup: (() => void) | undefined;

    if (user) {
      // Set initial status
      updateStatus('online');

      // Set up cleanup
      cleanup = () => {
        updateStatus('offline').catch(console.error);
      };

      // Handle page visibility changes
      const handleVisibilityChange = () => {
        updateStatus(document.hidden ? 'away' : 'online').catch(console.error);
      };

      document.addEventListener('visibilitychange', handleVisibilityChange);

      // Handle before unload
      window.addEventListener('beforeunload', cleanup);

      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('beforeunload', cleanup);
        if (cleanup) cleanup();
      };
    }
  }, [user, updateStatus]);

  // Show loading spinner until auth is ready
  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <DefaultSEO />
      <RouterProvider 
        router={router} 
        fallbackElement={<LoadingSpinner />}
      />
    </>
  );
}